import { NewButton } from "components/NewButton/NewButton";
import { LocalizationContext } from "context/localization";
import { useTranslationContext } from "context/translation";
import { FC, useContext } from "react";
import { FreeShippingTreshhold } from "./item-children/FreeShippingTreshhold";

type CartHeaderProps = {
  freeShippingThreshold: number | null;
  isButtonDisabled: boolean;
  onButtonClick: () => void;
  subtotal: number;
  total: number;
};

export const CartHeader: FC<CartHeaderProps> = ({
  freeShippingThreshold,
  isButtonDisabled,
  onButtonClick,
  subtotal,
  total,
}) => {
  const { formatPriceByLocale } = useContext(LocalizationContext);
  const { yourCart, checkout } = useTranslationContext();

  const formattedTotal = formatPriceByLocale(total);

  return (
    <div className="bg-white sticky top-14 md:top-[148px] z-10">
      <div className="container p-6 flex flex-col gap-6 md:flex-row md:items-center justify-between">
        <div className="flex flex-col gap-6">
          <h1 className="text-primary text-4xl md:text-5xl">{yourCart}</h1>
          <FreeShippingTreshhold
            freeShippingThreshold={freeShippingThreshold}
            iconClassName="stroke-[#005D6E]"
            subtotal={subtotal}
            textClassName="text-gray-500 text-[15px] font-medium"
          />
        </div>
        <NewButton
          onClick={onButtonClick}
          disabled={isButtonDisabled}
          className="w-full md:w-auto"
        >
          {checkout}
          <span className="text-secondary mx-2">•</span>
          {formattedTotal}
        </NewButton>
      </div>
    </div>
  );
};
